import { fetchFactory, urlUtils } from 'isotope-client'

export const getCampagnesList = filters => fetchFactory(urlUtils.buildUrlWithParams('/bo/campagne', filters))

export const getBornesNextCampagne = (idFerme) => fetchFactory(`/bo/campagne/${idFerme}`)

export const cloturerCampagne = (idCampagne) => fetchFactory(urlUtils.buildUrlWithParams('/bo/campagne', { idCampagne }), {
	method: 'PUT'
})

export const createCampagne = (idFerme) => fetchFactory(`/bo/campagne/${idFerme}`, {
	method: 'POST'
})

export const getAssolement = (filters, pageable) => fetchFactory(urlUtils.buildUrlWithParams('/assolement/list', pageable), {
	method: 'POST',
	body: JSON.stringify(filters)
})